import keyMirror from "ramda-extension/es/keyMirror";
export const validationDisplayTypes = keyMirror({
    COLLAPSE_TEXT: null,
    TOOLTIP: null,
    PLAIN_TEXT: null
});
